import { AfterViewInit, Component, ElementRef, Input, SecurityContext, ViewChild } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { marked } from "marked";

@Component({
    selector: "markdown-block",
    imports: [],
    templateUrl: "./markdown-block.component.html"
})
export class MarkdownBlockComponent implements AfterViewInit {
    @Input({ required: true }) public content!: string;
    @ViewChild("markdownContainer") private containerRef!: ElementRef<HTMLElement>;

    constructor(private domSanitizer: DomSanitizer) {

    }

    public ngAfterViewInit(): void {
        this.transform();
    }

    public ngOnChanges(): void {
        this.transform();
    }

    private transform()
    {
        if (!this.containerRef) {
            return;
        }
        
        var raw = this.content.trim();

        if (raw.length) {
            const markdown = marked.parse(raw) as string;
            const sanitized = this.domSanitizer.sanitize(SecurityContext.HTML, markdown);

            if (sanitized) {
                this.containerRef.nativeElement.innerHTML = sanitized;
            }
        }
    }
}